<script>
import get from 'lodash/get'
import StatusMap from '~/utils/status-map'
import { formatDate } from '@lib/utils/format-date'
export default {
  name: 'PublishingInformationTab',
  props: {
    publishing: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showFailWarning: true,
    }
  },
  computed: {
    externalPublishingStatus() {
      return get(this.publishing, 'external_publishing_status.status')
    },
    statusObj() {
      return StatusMap(this.publishing.status, this.externalPublishingStatus)
    },
  },
  methods: {
    formatDate,
  },
}
</script>

<template>
  <data-box
    header="Catalogue Publish Details"
    :status="statusObj"
    :class="$style.dataBox"
  >
    <data-list v-if="!loading">
      <dt>Date Created</dt>
      <dd>{{ formatDate(publishing.created_at) }}</dd>

      <dt>ID</dt>
      <dd>{{ publishing.id }}</dd>

      <dt>Products Added</dt>
      <dd>{{ publishing.objects_added }}</dd>

      <dt>Products Updated</dt>
      <dd>{{ publishing.objects_updated }}</dd>

      <dt>Products Deleted</dt>
      <dd>{{ publishing.objects_deleted }}</dd>

      <dt>Last Updated</dt>
      <dd>{{ formatDate(publishing.updated_at) }}</dd>
    </data-list>

    <div v-if="publishing.failureReason && showFailWarning">
      <div :class="$style.warningWrapper">
        <div :class="$style.warningHeader">
          <i class="el-icon-error" />
          <span :class="$style.warningTitle">
            {{ publishing.failureReason }}
          </span>
          <i
            class="el-icon-close"
            data-test="close-warning"
            @click="showFailWarning = false"
          />
        </div>
      </div>
    </div>
  </data-box>
</template>

<style lang="scss" module>
  .dataBox {
    :global {
      .el-card__body {
        position: relative;
      }
    }
  }
  .warningWrapper {
    position: absolute;
    top: 2rem;
    right: 2rem;
    max-width: 24rem;
    padding: rem(18px);
    color: var(--color-error);
    background-color: #FEF0F0;
    border-radius: rem(5px);
  }
  .warningTitle {
    margin: 0 .7rem;
    font-weight: 700;
  }
  .warningHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    :global {
      .el-icon-error {
        font-size: 1.8rem;
      }
      .el-icon-close {
        font-size: 1.2rem;
        color: #000;
        cursor: pointer;
      }
    }
  }
</style>
